import cx from 'classnames';
import PropTypes from 'prop-types';

const DividerBody = ({ data }) => {
  const { size, spacing, dashed } = data;

  const classes = cx('br-divider', {
    [size]: size,
    [`my-${spacing}`]: spacing,
    dashed,
  });

  return <span className={classes}></span>;
};

DividerBody.propTypes = {
  data: PropTypes.shape({
    size: PropTypes.string,
    spacing: PropTypes.string,
  }),

  isEditMode: PropTypes.bool,
};

export default DividerBody;
